import { noop } from "lodash";
import { PlanningEvent, PlanningEventGroup } from "../utils";
import { cn } from "../../../../utils";
import { CustomCalendarType } from "@ac-expo/api-types";
import { formatRGBColor } from "@ac-expo/utils";

type GroupedEventsCardProps = {
  group: Pick<PlanningEventGroup, "allEvents" | "allDay">;
  openGroupDetails?: (events: PlanningEvent[]) => void;
  hours: string;
  customCalendar?: CustomCalendarType;
};

const GroupedEventsCard = ({
  group,
  openGroupDetails,
  hours,
  customCalendar,
}: GroupedEventsCardProps) => {
  const { allDay, allEvents } = group;
  const overlappingCount = allEvents.length;
  const openDetails = openGroupDetails ?? noop;

  return (
    <button
      className={cn("h-full overflow-auto rounded-lg px-4 py-2", {
        "cursor-default": !openGroupDetails,
      })}
      tabIndex={0}
      onClick={() => openDetails(allEvents)}
      onKeyDown={() => openDetails(allEvents)}
      style={{
        backgroundColor: customCalendar?.polyAnimationColor
          ? formatRGBColor(customCalendar.polyAnimationColor)
          : "rgb(200, 200, 200)",
      }}
    >
      {!allDay && <p className="text-xs font-semibold text-white">{hours}</p>}
      <div className="flex justify-between pt-1">
        <p className="text-sm font-semibold text-white">
          {overlappingCount} animations
        </p>
        <span
          className={cn("text-primary-500 underline", {
            "cursor-default": !openGroupDetails,
          })}
        >
          Voir tout
        </span>
      </div>
    </button>
  );
};

export default GroupedEventsCard;
